module.exports = __webpack_public_path__ + "img/CNA1.a55aa9d3.jpg";